import React from 'react';
import { motion } from 'framer-motion';
import { HeadphonesIcon, MessageSquare, CheckCircle, Clock, AlertCircle } from 'lucide-react';
import { StatsCard } from '../components/StatsCard';
import { StatusBadge } from '../components/StatusBadge';
const tickets = [{
  id: 'TKT-2901',
  subject: 'Payment not received for ride #FAMO-9210',
  user: 'Mike Ross (Rider)',
  category: 'Payment',
  priority: 'high',
  status: 'open',
  created: '2 hours ago'
}, {
  id: 'TKT-2900',
  subject: 'App crashes when opening map',
  user: 'Alice Smith (User)',
  category: 'App Bug',
  priority: 'medium',
  status: 'in_progress',
  created: '4 hours ago'
}, {
  id: 'TKT-2899',
  subject: 'Driver was rude and unsafe',
  user: 'Sarah Connor (User)',
  category: 'Ride Issue',
  priority: 'high',
  status: 'open',
  created: '5 hours ago'
}, {
  id: 'TKT-2898',
  subject: 'Change bank account details',
  user: 'Bruce Wayne (Rider)',
  category: 'Account',
  priority: 'low',
  status: 'resolved',
  created: '1 day ago'
}, {
  id: 'TKT-2897',
  subject: 'Refund request for cancelled ride',
  user: 'Clark Kent (User)',
  category: 'Payment',
  priority: 'medium',
  status: 'resolved',
  created: '1 day ago'
}, {
  id: 'TKT-2896',
  subject: 'Cannot upload profile picture',
  user: 'Diana Prince (Rider)',
  category: 'App Bug',
  priority: 'low',
  status: 'resolved',
  created: '2 days ago'
}];
export function Support() {
  return <div className="space-y-6" data-id="element-1277">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-1278">
        <StatsCard title="Open Tickets" value="23" trend={5} icon={AlertCircle} color="gold" delay={0} data-id="element-1279" />
        <StatsCard title="In Progress" value="12" trend={-2} icon={Clock} color="blue" delay={0.1} data-id="element-1280" />
        <StatsCard title="Resolved Today" value="8" trend={15} icon={CheckCircle} color="green" delay={0.2} data-id="element-1281" />
        <StatsCard title="Avg Response Time" value="2.4h" trend={-10} icon={HeadphonesIcon} color="purple" delay={0.3} data-id="element-1282" />
      </div>

      <div className="flex gap-4 border-b border-slate-200 pb-1" data-id="element-1283">
        <button className="px-4 py-2 text-sm font-medium text-famo-navy border-b-2 border-famo-gold" data-id="element-1284">
          All Tickets
        </button>
        <button className="px-4 py-2 text-sm font-medium text-slate-500 hover:text-slate-700" data-id="element-1285">
          High Priority
        </button>
        <button className="px-4 py-2 text-sm font-medium text-slate-500 hover:text-slate-700" data-id="element-1286">
          Unassigned
        </button>
      </div>

      <div className="grid grid-cols-1 gap-4" data-id="element-1287">
        {tickets.map((ticket, idx) => <motion.div key={ticket.id} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1 * idx
      }} className="bg-white p-6 rounded-xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-1288">
            <div className="flex items-start gap-4" data-id="element-1289">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${ticket.priority === 'high' ? 'bg-red-100 text-red-600' : ticket.priority === 'medium' ? 'bg-yellow-100 text-yellow-600' : 'bg-blue-100 text-blue-600'}`} data-id="element-1290">
                <MessageSquare size={20} data-id="element-1291" />
              </div>
              <div data-id="element-1292">
                <div className="flex items-center gap-2 mb-1" data-id="element-1293">
                  <span className="text-xs font-mono text-slate-400" data-id="element-1294">
                    {ticket.id}
                  </span>
                  <StatusBadge status={ticket.priority} data-id="element-1295" />
                  <span className="text-xs text-slate-500" data-id="element-1296">
                    • {ticket.category}
                  </span>
                </div>
                <h3 className="text-base font-semibold text-slate-900 mb-1" data-id="element-1297">
                  {ticket.subject}
                </h3>
                <p className="text-sm text-slate-500" data-id="element-1298">
                  From:{' '}
                  <span className="font-medium text-slate-700" data-id="element-1299">
                    {ticket.user}
                  </span>
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4 md:border-l md:border-slate-100 md:pl-6 md:w-64 justify-between md:justify-end" data-id="element-1300">
              <div className="text-right" data-id="element-1301">
                <StatusBadge status={ticket.status} className="mb-1 inline-block" data-id="element-1302" />
                <p className="text-xs text-slate-400" data-id="element-1303">{ticket.created}</p>
              </div>
              <button className="px-4 py-2 bg-slate-50 text-slate-600 text-sm font-medium rounded-lg hover:bg-slate-100 transition-colors" data-id="element-1304">
                View
              </button>
            </div>
          </motion.div>)}
      </div>
    </div>;
}